import React, {Component, createRef, useState} from "react";
import {connect} from "react-redux";
import NumberFormat from "react-number-format";
import {Spinner} from "react-bootstrap";
import {Button, Modal, Select, SelectActions} from "../../../components";
import {Constants, Globals, axios} from "../../../utils";
import Menu from "../../menu";
import ModalProducts from "./modal-products";
import CreateEditClient from "../../clients/create_edit_client";

import LocationPinIcon from "../../../assets/icons/location-pin.png";
import LeftArrowIcon from "../../../assets/icons/left-arrow.png";
import CloseIcon from "../../../assets/icons/close-black.png";
import AddIcon from "../../../assets/icons/add-circle.png";
import ReturnIcon from "../../../assets/icons/return.png";
import DebitIcon from "../../../assets/icons/debit.png";
import Return from "./return";
import Debit from "./debit";

const TAB = {
  NEW: 1,
  RETURN: 2,
  DEBIT: 3,
};

const STEP = {
  PRODUCTS: 1,
  PAYMENT: 2,
};

function parse(value) {
  return parseFloat(parseFloat(value).toFixed(2));
}

function format(value) {
  return parseFloat(value).toFixed(2);
}

class NewRequest extends Component {
  state = {
    tab: TAB.NEW,
    step: STEP.PRODUCTS,
    visible_products: false,
    visible_client: false,
    showLoteAgotadoModal: false,
    isSubmittedForm: false,
    isLoadingWarehouses: false,
    created_client: null,
    form: {
      user: this.props.user,
      user_id: this.props.user.id,
      seller_id: this.props.user.id,
      search: "",
      client_id: "",
      status_payment: Constants.PAYMENT_TYPES.PAID,
      discount: "",
      initial_payment: "",
      credit_days: "",
      change: 0,
      comments: "",
      client: null,
      details: [],
      methods_selected: [],
      is_copy: false,
      warehouse_id: "",
      nextBillNumber: null,
    },
    totals: {
      subtotal_usd: 0,
      subtotal_bs: 0,
      paid_usd: 0,
      paid_bs: 0,
      left_usd: 0,
      left_bs: 0,
      total_bs: 0,
      total_usd: 0,
      change_bs: 0,
      change_usd: 0,
      iva_8_bs: 0,
      iva_8_usd: 0,
      iva_16_bs: 0,
      iva_16_usd: 0,
      iva_31_bs: 0,
      iva_31_usd: 0,
      iva_bs: 0,
      iva_usd: 0,
      igtf_bs: 0,
      igtf_usd: 0,
    },
    clients: [],
    zones: [],
    methods: [],
    exchangeRate: 0,
    warehouses: [],
    formatWarehouses: [],
    clientOrdersToPay: null,
    client_categories: [],
    showSuccessModal: false,
    showIgtfModal: false,
    debitData: null,
  };

  debounce = createRef();

  componentDidMount() {
    this.getWarehouses();
    this.getClients();
    this.getZones();
    this.getExchangeRate();
    this.getPaymentMethods();
    this.getClientCategories();
    this.getNextBillNumber();

    const fromQuote = sessionStorage.getItem("quoteToFiscal") || false;
    if (fromQuote) this.fillQuote();
  }

  componentWillUnmount() {
    sessionStorage.removeItem("quoteToFiscal");
  }

  toggleLoteAgotadoModal = () => {
    this.setState((s) => ({showLoteAgotadoModal: !s.showLoteAgotadoModal}));
  };

  getItemStock = (item) => {
    if (!item) return 0;
    if (item.stock_warehouse !== undefined) return item.stock_warehouse;
    if (item.total_quantity !== undefined) return item.total_quantity;
    return item.stock || 0;
  };

  fillQuote = async () => {
    const quoteString = sessionStorage.getItem("quoteToFiscal");
    const quote = JSON.parse(quoteString);

    const formatProduct = (item) => {
      if (!item) return;

      const warehouse_id = Number(this.props.user.warehouse_principal);
      let total_quantity = undefined;

      const wh = this.state.warehouses.find((i) => i.id === warehouse_id);
      if (wh) {
        const wp = wh.products.find((i) => i.product_id === item.id);
        total_quantity = wp?.total_quantity;
        if (wp?.product) item.product = Globals.copy(wp.product);
      }

      let stock = item.product.stock;
      let name = item.product.name;

      if (item.product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const size_color = item.product.size_colors.find(
          (sc) => sc.size_id === item.size_id && sc.color_id === item.color_id,
        );

        stock = size_color?.stock || 0;
        if (!!size_color?.color) name += `, ${size_color.color.name}`;
        if (!!size_color?.size) name += `, ${size_color.size.name}`;
      }

      return {
        ...item.product,
        ...item,
        product: undefined,
        price: item.selected_price || item.sale_price,
        sale_price: item.selected_price || item.sale_price,
        selected_price: item.selected_price || item.sale_price,
        name,
        stock,
        total_quantity,
        warehouse_id,
      };
    };

    await this.setState((state) => ({
      created_client: quote.client,
      form: {
        ...state.form,
        user_id: this.props.user.id,
        quote_id: quote.quote_id,
        whatsapp_id: quote.whatsapp_id,
        seller_id: this.props.user.id,
        client_id: quote.client_id,
        client: quote.client,
        discount: quote.discount,
        initial_payment: quote.initial_payment,
        credit_days: quote.credit_days,
        comments: quote.information,
        details: quote.details?.map(formatProduct),
      },
    }));
    this.setTotals();
  };

  resetForm = () => {
    this.setState(
      (state) => ({
        form: {
          ...state.form,
          user_id: this.props.user.id,
          seller_id: this.props.user.id,
          search: "",
          client_id: "",
          status_payment: Constants.PAYMENT_TYPES.PAID,
          discount: "",
          initial_payment: "",
          credit_days: "",
          change: 0,
          comments: "",
          client: null,
          details: [],
          methods_selected: [],
          is_copy: false,
          warehouse_id: "",
          nextBillNumber: null,
        },
        totals: {
          ...state.totals,
          subtotal_usd: 0,
          subtotal_bs: 0,
          paid_usd: 0,
          paid_bs: 0,
          left_usd: 0,
          left_bs: 0,
          total_bs: 0,
          total_usd: 0,
          change_bs: 0,
          change_usd: 0,
          iva_bs: 0,
          iva_usd: 0,
          igtf_bs: 0,
          igtf_usd: 0,
        },
      }),
      () => {
        this.getNextBillNumber();
      },
    );
  };

  getClients = async () => {
    Globals.setLoading();

    try {
      const filter = {
        user_id: this.state.form.user_id,
        search: this.state.form.search,
      };

      const res = await axios.post("web/admin/orders/clients", filter);
      if (!res.data?.clients) throw Error("No se encontraron los clientes");

      const activeClients = res.data.clients.data.filter(
        (c) => c.status === Constants.STATUS_ACTIVE,
      );

      let clients = activeClients.map((c) => ({
        ...c,
        value: c.id,
        label: !!c.document ? `${c.name} - Rif ${c.document}` : c.name,
      }));

      if (this.state.created_client) {
        clients = clients.filter((i) => i.id != this.state.created_client?.id);
        clients.unshift({
          ...this.state.created_client,
          value: this.state.created_client.id,
          label: !!this.state.created_client.document
            ? `${this.state.created_client.name} - Rif ${this.state.created_client.document}`
            : this.state.created_client.name,
        });
      }

      this.setState({clients});
    } catch (error) {
      Globals.showError(error?.message);
      console.log("NewRequest -> getClients -> catch:", error);
    }

    Globals.quitLoading();
  };

  getZones = async () => {
    Globals.setLoading();

    axios
      .post("web/admin/zones", {user_id: this.props.user.id})
      .then(({data}) => {
        data.zones.unshift({id: "", name: "Todos"});
        this.setState({zones: data.zones.filter((item) => item.id)});
      })
      .catch(() => Globals.showError())
      .then(() => Globals.quitLoading());
  };

  getExchangeRate = async () => {
    try {
      const filter = {user_id: this.state.form.user_id};

      const res = await axios.post("admin/conversions/getbcv", filter);
      if (!res.data?.conversion)
        throw Error("Debe establecer una tasa de cambio para continuar");

      await this.setState({exchangeRate: res.data?.conversion || 0});
      this.setTotals();
    } catch (error) {
      Globals.showError(error?.message);
      console.log("NewRequest -> getExchangeRate -> catch:", error);
    }
  };

  getPaymentMethods = async () => {
    try {
      const filter = {
        user_id: this.state.form.user_id,
      };

      const res = await axios.post("web/admin/orders/methods", filter);
      if (!res.data?.methods)
        throw Error("No se encontraron los métodos de pago");

      this.setState({methods: res.data?.methods});
    } catch (error) {
      Globals.showError(error?.message);
      console.log("NewRequest -> getPaymentMethods -> catch:", error);
    }
  };

  getClientCategories = async () => {
    await axios
      .post("admin/clients/categories", {
        user_id: this.props.user.id,
        is_select: true,
      })
      .then(({data}) => {
        data.categories.unshift({id: "x", name: "Sin Categoría"});
        data.categories.unshift({id: "", name: "Todas"});

        this.setState({
          client_categories: data.categories,
        });
      })
      .catch(() => Globals.showError())
      .then(() => Globals.quitLoading());
  };

  getWarehouses = async () => {
    try {
      this.setState({isLoadingWarehouses: true});

      const data = {
        web: true,
        user_id: this.props.user.id,
        is_select: true,
        warehouse_id:
          this.props.user.level_id == Constants.ROLE_ADMIN
            ? null
            : this.props.user.warehouse_id,
        unique_by_size_color: true,
      };

      const res = await axios.post("web/admin/warehouses", data);
      if (res.data?.warehouses) {
        const formatWarehouses = res.data.warehouses.map((Item) => ({
          value: Item.id,
          label: Item.name,
        }));

        const mainIdx = formatWarehouses.findIndex(
          (x) => x.value === this.props.user.warehouse_principal,
        );
        if (mainIdx >= 0) {
          const main = formatWarehouses[mainIdx];
          formatWarehouses.splice(mainIdx, 1);
          formatWarehouses.unshift(main);
        }

        await this.setState({
          warehouses: res.data.warehouses,
          formatWarehouses: formatWarehouses,
        });

        if (this.state.form.quote_id || this.state.form.whatsapp_id)
          this.fillQuote();
      }
    } catch (error) {
      Globals.showError();
      console.log("NewRequest -> getWarehouses -> catch: ", error);
    }
    this.setState({isLoadingWarehouses: false});
  };

  change = async (value, target) => {
    await this.setState((state) => ({form: {...state.form, [target]: value}}));
    if (target === "discount" || target === "status_payment") this.setTotals();
  };

  changeTab = (tab) => {
    this.setState({tab});
  };

  changeStep = (step) => {
    this.setState({step});
  };

  goToPaymentStep = () => {
    if (!this.state.form.client_id)
      return Globals.showError("Debe seleccionar el cliente");

    this.changeStep(STEP.PAYMENT);
  };

  getNextBillNumber = async () => {
    try {
      const filter = {
        user_id: this.state.form.user_id,
        type: "bill_number",
      };

      const res = await axios.post("web/admin/orders/nextCorrelative", filter);
      if (!res.data?.result)
        throw Error("No se encontro el siguiente correlative");

      this.setState((state) => ({
        form: {...state.form, nextBillNumber: res.data?.nextBillNumber},
      }));
    } catch (error) {
      Globals.showError(error?.message);
      console.log("getNextBillNumber -> getNextBillNumber -> catch:", error);
    }
  };

  goBack = (toPrevModule = false) => {
    if (this.state.step === STEP.PAYMENT && !toPrevModule)
      return this.changeStep(STEP.PRODUCTS);
    this.props.history.replace("/report-sale");
  };

  setTotals = async () => {
    const {form, exchangeRate} = this.state;
    const products = [...form.details];
    const generalDiscountRate = form.discount / 100;

    let baseWithoutGeneral_usd = 0;
    products.forEach((prod) => {
      const qty =
        prod.decimal_stock === Constants.DECIMAL_STOCK.YES
          ? prod.quantity
          : parseInt(prod.quantity, 10);

      const lineGross = qty * prod.sale_price;
      const indivDiscount =
        prod.discount > 0 ? (lineGross * prod.discount) / 100 : 0;

      prod.baseAfterIndiv_usd = parse(lineGross - indivDiscount);
      baseWithoutGeneral_usd += prod.baseAfterIndiv_usd;
    });

    const generalDiscount_usd = baseWithoutGeneral_usd * generalDiscountRate;
    const netBase_usd = parse(baseWithoutGeneral_usd - generalDiscount_usd);

    let totalIva_usd = 0;
    const ivaByRate_usd = {
      [Constants.PRODUCT_IVA.OCHO]: 0,
      [Constants.PRODUCT_IVA.DIECISEIZ]: 0,
      [Constants.PRODUCT_IVA.TREINTAIUNO]: 0,
    };

    products.forEach((prod) => {
      const proportion =
        baseWithoutGeneral_usd > 0
          ? prod.baseAfterIndiv_usd / baseWithoutGeneral_usd
          : 0;
      const lineNetBase = parse(netBase_usd * proportion);

      if (prod.exento === Constants.PRODUCT_EXENTO.NO) {
        const ivaLine = parse((lineNetBase * prod.iva_porcentage) / 100);
        prod.iva_usd = ivaLine;
        totalIva_usd += ivaLine;
        ivaByRate_usd[prod.iva] += ivaLine;
        prod.subtotal = parse(lineNetBase + ivaLine);
      } else {
        prod.iva_usd = 0;
        prod.subtotal = lineNetBase;
      }
    });

    const foreignPaid_usd = parse(
      form.methods_selected
        .filter((m) => !m.isLocalCurrency)
        .reduce((sum, m) => sum + Number(m.amount), 0),
    );
    const maxIgtfBase_usd = parse(netBase_usd + totalIva_usd);
    const igtfBase_usd = Math.min(maxIgtfBase_usd, foreignPaid_usd);
    const igtf_usd = parse((igtfBase_usd * Constants.TAXES.IGTF) / 100);

    const total_usd = parse(
      form.status_payment === Constants.PAYMENT_TYPES.PAID
        ? netBase_usd + totalIva_usd + igtf_usd
        : netBase_usd + totalIva_usd,
    );

    const paid_usd = parse(
      form.methods_selected.reduce((sum, m) => sum + Number(m.amount), 0),
    );
    let change_usd = 0;
    let left_usd = parse(total_usd - paid_usd);
    if (left_usd < 0) {
      change_usd = parse(-left_usd);
      left_usd = 0;
    }

    const netBase_bs = parse(netBase_usd * exchangeRate);
    const iva_bs = parse(totalIva_usd * exchangeRate);
    const igtf_bs = parse(igtf_usd * exchangeRate);
    const total_bs = parse(total_usd * exchangeRate);
    const paid_bs = parse(
      form.methods_selected.reduce((sum, m) => sum + Number(m.amount_bs), 0),
    );
    let change_bs = parse(change_usd * exchangeRate);
    let left_bs = parse(total_bs - paid_bs);
    if (left_bs < 0) {
      change_bs = parse(-left_bs);
      left_bs = 0;
    }

    await this.setState({
      form: {
        ...form,
        details: products,
        change: change_usd,
      },
      totals: {
        subtotal_without_disc_usd: parse(baseWithoutGeneral_usd),
        discount_usd: parse(generalDiscount_usd),
        netBase_usd,
        iva_usd: totalIva_usd,
        iva_8_usd: ivaByRate_usd[Constants.PRODUCT_IVA.OCHO],
        iva_16_usd: ivaByRate_usd[Constants.PRODUCT_IVA.DIECISEIZ],
        iva_31_usd: ivaByRate_usd[Constants.PRODUCT_IVA.TREINTAIUNO],
        igtf_usd,
        total_usd,
        paid_usd,
        change_usd,
        left_usd,

        subtotal_without_disc_bs: parse(baseWithoutGeneral_usd * exchangeRate),
        discount_bs: parse(generalDiscount_usd * exchangeRate),
        netBase_bs,
        iva_bs,
        iva_8_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.OCHO] * exchangeRate,
        ),
        iva_16_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.DIECISEIZ] * exchangeRate,
        ),
        iva_31_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.TREINTAIUNO] * exchangeRate,
        ),
        igtf_bs,
        total_bs,
        paid_bs,
        change_bs,
        left_bs,
      },
    });
  };

  debouncingSearchClient = async (search) => {
    if (this.debounce.current) clearTimeout(this.debounce.current);

    await this.change(undefined, "client_id");
    await this.change(search, "search");
    this.debounce.current = setTimeout(async () => {
      this.getClients();
    }, 1000);
  };

  onSelectClient = async (id) => {
    const client = this.state.clients.find((client) => client.id === id);
    await this.change(id, "client_id");
    await this.change(client, "client");
  };

  toggleClientModal = () => {
    this.setState((state) => ({visible_client: !state.visible_client}));
  };

  toggleProductsModal = () => {
    if (!this.state.exchangeRate)
      return Globals.showError(
        "Debe establecer una tasa de cambio para continuar",
      );
    this.setState((state) => ({visible_products: !state.visible_products}));
  };

  addProduct = async (product, warehouse_id) => {
    this.setState((state) => ({
      form: {
        ...state.form,
        warehouse_id: warehouse_id,
      },
    }));

    let productIndex;
    let products = Globals.copy(this.state.form.details);

    productIndex =
      product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR
        ? products.findIndex(
            (p) =>
              p.id === product.id &&
              p.size_id === product.size_id &&
              p.color_id === product.color_id,
          )
        : products.findIndex((p) => p.id === product.id);

    if (productIndex >= 0) {
      const currentStock = this.getItemStock(products[productIndex]);
      const newQuantity = products[productIndex].quantity + product.quantity;
      if (newQuantity > currentStock)
        return Globals.showError(
          `No hay suficiente stock (${currentStock} disponibles)`,
        );

      products[productIndex].quantity = newQuantity;
      products[productIndex].subtotal += product.subtotal;
    } else {
      products = [...products, product];
    }

    await this.change(products, "details");
    await this.setTotals();
  };

  removeProduct = async (index) => {
    let products = this.state.form.details.filter((_, idx) => idx !== index);
    await this.change(products, "details");
    await this.setTotals();
  };

  oneMoreProduct = async (index) => {
    const products = Globals.copy(this.state.form.details);
    const product = products[index];
    let qty = Number(products[index].quantity);
    let newQuantity = qty + 1;
    if (product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
      newQuantity = parseFloat(qty + 1).toFixed(2);
    }

    const stockToValidate = this.getItemStock(products[index]);

    if (Number(newQuantity) > Number(stockToValidate))
      return Globals.showError(
        `No hay suficiente stock de ${products[index].name}`,
      );

    products[index].quantity = newQuantity;
    await this.change(products, "details");
    this.setTotals();
  };

  oneLessProduct = async (index) => {
    const products = Globals.copy(this.state.form.details);
    const product = products[index];
    let qty = Number(products[index].quantity);
    let newQuantity = qty - 1;
    if (product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
      newQuantity = parseFloat(qty - 1).toFixed(2);
    }

    if (newQuantity < 1) return;

    const stockToValidate = this.getItemStock(products[index]);

    if (Number(newQuantity) > Number(stockToValidate)) {
      newQuantity = stockToValidate;
      Globals.showError(`No hay suficiente stock de ${products[index].name}`);
    }

    products[index].quantity = newQuantity;
    await this.change(products, "details");
    this.setTotals();
  };

  changeManual = async (index, quantity) => {
    const products = Globals.copy(this.state.form.details);
    let newQuantity = quantity;

    if (products[index]?.decimal_stock === Constants.DECIMAL_STOCK.NO) {
      newQuantity = newQuantity === "" ? newQuantity : parseInt(newQuantity);
    } else {
      newQuantity = newQuantity.replace(/,/g, ".");
    }

    products[index].quantity = newQuantity;
    await this.change(products, "details");
    this.setTotals();
  };

  addPaymentMethod = async (id) => {
    const method = this.state.methods.find((m) => m.id === id);
    const isLocalCurrency = Constants.LOCAL_CURRENCIES.includes(method.id);
    const newMethod = {
      id,
      isLocalCurrency,
      amount: "",
      amount_bs: "",
      name: method.name,
    };

    const hasLocalCurrencyMethod = this.state.form.methods_selected.some(
      (m) => m.isLocalCurrency,
    );

    if (!newMethod.isLocalCurrency && hasLocalCurrencyMethod) {
      return Globals.showError(
        "Por favor, ingrese primero los pagos en dólares ($).<br>Luego podrá añadir los pagos en bolívares (BS).<br>Esto nos ayuda a cumplir con las regulaciones fiscales y ofrecerle un mejor servicio.",
      );
    }

    await this.setState((state) => ({
      form: {
        ...state.form,
        methods_selected: [...state.form.methods_selected, newMethod],
      },
    }));
    this.setTotals();
  };

  changePaymentAmount = async (index, amount, isLocalCurrency = false) => {
    const payments = Globals.copy(this.state.form.methods_selected);

    if (isLocalCurrency) {
      payments[index].amount = parse(
        parse(amount || 0) / this.state.exchangeRate,
      );
      payments[index].amount_bs = amount;
    } else {
      payments[index].amount = amount;
      payments[index].amount_bs = parse(
        parse(amount || 0) * this.state.exchangeRate,
      );
    }

    await this.setState((state) => ({
      form: {
        ...state.form,
        methods_selected: payments,
      },
    }));
    this.setTotals();
  };

  removePaymentMethod = async (index) => {
    const methods_selected = this.state.form.methods_selected.filter(
      (_, idx) => idx !== index,
    );

    await this.setState((state) => ({
      form: {
        ...state.form,
        methods_selected,
      },
    }));
    this.setTotals();
  };

  isValidForm = () => {
    const onError = (msg) => {
      this.setState({isSubmittedForm: false});
      Globals.showError(msg);
      return false;
    };

    this.setState({isSubmittedForm: true});
    const {form, totals} = this.state;

    if (form.details.some((i) => !i.quantity || i.quantity < 1))
      return onError("Debe seleccionar la cantidad de todos los productos");

    if (form.details.some((i) => !i.sale_price))
      return onError("Debe seleccionar el precio de todos los productos");

    if (form.methods_selected.some((i) => i.amount <= 0))
      return onError("Debe ingresar el monto de cada método de pago");

    if (form.status_payment === Constants.PAYMENT_TYPES.TO_PAY) {
      if (form.credit_days <= 0)
        return onError("Debe ingresar los días de crédito");

      if (parse(form.initial_payment) >= totals.total_usd)
        return onError(
          "El pago inicial no puede ser igual o mayor al monto total. Este es un pedido por cobrar",
        );

      if (parse(form.initial_payment) > 0 && !form.methods_selected.length)
        return onError("Debe seleccionar al menos 1 método de pago");

      if (
        totals.paid_usd > 0 &&
        totals.paid_usd !== parse(form.initial_payment)
      )
        return onError(
          "La suma de los métodos de pago debe ser igual al pago inicial",
        );

      if (!form.credit_days) {
        return onError("Debe indicar la cantidad de días de crédito");
      }
    } else {
      const tolerance = 0.0001;

      if (Math.abs(totals.paid_usd - totals.total_usd) > tolerance) {
        return onError(
          "La suma de los métodos de pago debe ser igual al total",
        );
      }
    }

    if (form.discount !== "" && form.discount < 0)
      return onError(
        "El porcentaje de descuento general no puede ser negativo",
      );

    if (form.discount !== "" && form.discount > 100)
      return onError(
        "El porcentaje de descuento general no puede ser mayor a 100%",
      );

    return true;
  };

  submit = async () => {
    if (!this.isValidForm()) return;

    const {form, totals} = this.state;

    const data = {
      ...form,
      currency: this.props.currency,
      details: JSON.stringify(form.details),
      methods_selected: JSON.stringify(form.methods_selected),
      initial_payment:
        form.status_payment === Constants.PAYMENT_TYPES.PAID
          ? null
          : form.initial_payment,
      credit_days:
        form.status_payment === Constants.PAYMENT_TYPES.PAID
          ? null
          : parseInt(form.credit_days),
      discount: form.discount || 0,
      iva: totals.iva_usd || 0,
      iva_bs: totals.iva_bs || 0,
      igtf: totals.igtf_usd || 0,
      igtf_bs: totals.igtf_bs || 0,
      total_bs: totals.total_bs || 0,
      fiscal: true,
    };

    try {
      const res = await axios.post("web/admin/orders/store", data);

      if (res.data?.lote_agotado || res.data?.result === false) {
        if (
          res.data?.lote_agotado ||
          res.data?.error?.includes("Lote de Formas Libres agotado")
        ) {
          this.setState({showLoteAgotadoModal: true, isSubmittedForm: false});
          return;
        }
        Globals.showError(res.data?.error || "No se pudo procesar el pedido.");
        this.setState({isSubmittedForm: false});
        return;
      }

      if (res.data?.order) {
        const res_fiscal = await axios.post("admin/orders/fiscal-bill", {
          user_id: this.props.user.id,
          order_id: res.data.order.id,
        });

        if (
          res_fiscal.data?.lote_agotado ||
          res_fiscal.data?.error?.includes("Lote de Formas Libres agotado")
        ) {
          this.setState({showLoteAgotadoModal: true, isSubmittedForm: false});
          return;
        } else if (res_fiscal.data?.result) {
          Globals.showSuccess("Factura enviada a la impresora");
        } else {
          Globals.showError("Ocurrió un problema al enviar la factura fiscal");
        }
      }

      if (res.data?.debit_note) {
        this.setState({
          showSuccessModal: true,
          debitData: res.data.debit_note,
          isSubmittedForm: false,
        });
        return;
      }

      Globals.showSuccess("Se ha creado su pedido correctamente");
      this.resetForm();
      this.goBack();
    } catch (error) {
      const errorData = error?.response?.data;
      if (
        errorData?.lote_agotado ||
        errorData?.error?.includes("Lote de Formas Libres agotado")
      ) {
        this.setState({showLoteAgotadoModal: true, isSubmittedForm: false});
      } else if (error.response?.data?.error) {
        Globals.showError(error.response.data.error);
      } else {
        Globals.showError(error);
      }
      console.log("NewRequest -> submit -> catch:", error);
    }

    this.setState({isSubmittedForm: false});
  };

  openPrintable = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.click();
  };

  checkedChange = (newValue) => {
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        is_copy: newValue,
      },
    }));
  };

  renderLoteAgotadoModal = () => {
    const {showLoteAgotadoModal} = this.state;
    if (!showLoteAgotadoModal) return null;
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999,
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            width: "460px",
            maxWidth: "90%",
            overflow: "hidden",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
            textAlign: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#fce8e6",
              padding: "24px 20px 16px 20px",
              borderBottom: "1px solid #f5c6cb",
            }}
          >
            <div
              style={{
                fontSize: "44px",
                color: "#d93025",
                lineHeight: "1",
                marginBottom: "8px",
              }}
            >
              ⚠️
            </div>
            <h2
              style={{
                color: "#d93025",
                margin: 0,
                fontSize: "26px",
                fontWeight: "bold",
              }}
            >
              ¡Advertencia!
            </h2>
          </div>
          <div style={{padding: "24px 30px"}}>
            <p
              style={{
                color: "#3c4043",
                fontSize: "15px",
                lineHeight: "1.5",
                margin: 0,
              }}
            >
              Lote de Formas Libres agotado. Por favor, configure un nuevo lote
              autorizado por la imprenta para continuar
            </p>
          </div>
          <div
            style={{
              padding: "0 20px 20px 20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              onClick={this.toggleLoteAgotadoModal}
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: "#000",
                fontWeight: "bold",
                fontSize: "16px",
                cursor: "pointer",
                padding: "8px 24px",
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      form,
      clients,
      methods,
      isSubmittedForm,
      step,
      tab,
      totals,
      visible_client,
      visible_products,
      zones,
      clientOrdersToPay,
      isLoadingWarehouses,
      client_categories,
    } = this.state;

    const total_client_to_pay = clientOrdersToPay?.to_pay_orders?.reduce(
      (accumulator, item) => accumulator + item.to_pay,
      0,
    );

    const filteredPaymentMethods = methods.filter((m) => {
      return !this.state.form.methods_selected.some((ms) => ms.id === m.id);
    });

    const filtered_clientCategories = client_categories.filter((Item) => {
      return Item.id && Item.id > 0;
    });

    if (tab === TAB.RETURN)
      return (
        <Menu
          history={this.props.history}
          hideContentBreadcumbs
          leftSlot={
            <HeaderContent
              tab={tab}
              onChangeTab={this.changeTab}
              onGoBack={() => this.goBack()}
            />
          }
        >
          {this.renderLoteAgotadoModal()}
          <Return />
        </Menu>
      );

    if (tab === TAB.DEBIT)
      return (
        <Menu
          history={this.props.history}
          hideContentBreadcumbs
          leftSlot={
            <HeaderContent
              tab={tab}
              onChangeTab={this.changeTab}
              onGoBack={() => this.goBack()}
            />
          }
        >
          {this.renderLoteAgotadoModal()}
          <Debit />
        </Menu>
      );

    if (step === STEP.PAYMENT)
      return (
        <Menu
          history={this.props.history}
          hideContentBreadcumbs
          leftSlot={
            <HeaderContent
              tab={tab}
              onChangeTab={this.changeTab}
              onGoBack={() => this.goBack()}
            />
          }
        >
          {this.renderLoteAgotadoModal()}
          <Modal
            title=""
            visible={this.state.showSuccessModal}
            onClose={() => {
              this.setState({
                showSuccessModal: false,
                showIgtfModal: true,
              });
            }}
          >
            <div
              style={{
                padding: "2rem 1.5rem 1.5rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {/* Ícono animado de éxito */}
              <div
                style={{
                  width: "64px",
                  height: "64px",
                  borderRadius: "50%",
                  backgroundColor: "#E8F5E9",
                  color: "#2ECC71",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "1.25rem",
                }}
              >
                <i className="fa fa-check" style={{fontSize: "32px"}} />
              </div>

              {/* Mensaje principal */}
              <h4
                style={{
                  fontSize: "1.35rem",
                  fontWeight: "700",
                  color: "#2C3E50",
                  margin: "0 0 0.5rem 0",
                }}
              >
                ¡Pedido Creado!
              </h4>

              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#6C7A89",
                  margin: "0 0 1.75rem 0",
                  lineHeight: "1.4",
                }}
              >
                El pedido se ha procesado exitosamente.
              </p>

              {/* Botón Aceptar */}
              <Button
                color="green"
                style={{
                  minWidth: "140px",
                  padding: "0.6rem 1.5rem",
                  fontSize: "1rem",
                  fontWeight: "600",
                  borderRadius: "6px",
                  boxShadow: "0 4px 12px rgba(46, 204, 113, 0.25)",
                }}
                onClick={() => {
                  this.setState({
                    showSuccessModal: false,
                    showIgtfModal: true,
                  });
                }}
              >
                Aceptar
              </Button>
            </div>
          </Modal>

          <Modal
            title="Generación de Nota de Débito por IGTF (3%)"
            visible={this.state.showIgtfModal}
            onClose={() => {
              this.setState({showIgtfModal: false});
              this.resetForm();
              this.goBack();
            }}
          >
            <div className="p-3 text-center">
              <p>
                Se ha detectado un pago/abono en divisas de pedido a crédito. A
                continuación se detallan los datos para emisión de Nota de
                Débito Fiscal:
              </p>
              <div className="bg-light p-3 border rounded text-left">
                <p>
                  <b>Factura N°:</b> {this.state.form.nextBillNumber || "S/N"}
                </p>
                <p>
                  <b>Monto Percibido en divisas:</b> ${" "}
                  {this.state.debitData?.usd_paid}
                </p>
                <p>
                  <b>Tasa de cambio (BCV):</b> Bs.{" "}
                  {Globals.newFormatMiles(this.state.exchangeRate, 4)}
                </p>
                <p>
                  <b>Monto Total Nota de Débito (3%):</b> ${" "}
                  {this.state.debitData?.total}
                </p>
              </div>
              <div
                className="alert alert-info mt-3"
                style={{
                  backgroundColor: "#e8f4fd",
                  color: "#1d6f8a",
                  borderRadius: "8px",
                  padding: "12px",
                }}
              >
                <b>Concepto Automático:</b>
                <br />
                {this.state.debitData?.motive ||
                  `Recargo por concepto de IGTF (3%) correspondiente al pago en divisas de la Factura N° ${this.state.form.nextBillNumber || "S/N"} del Pedido N° ${this.state.debitData?.order_id}.`}
              </div>
            </div>
          </Modal>
          <div id="report-sale-create">
            <main>
              <section className="payment">
                <section className="payment-type">
                  <Button
                    block
                    color={
                      form.status_payment === Constants.PAYMENT_TYPES.PAID
                        ? " "
                        : "white"
                    }
                    onClick={() =>
                      this.change(
                        Constants.PAYMENT_TYPES.PAID,
                        "status_payment",
                      )
                    }
                  >
                    PAGADO
                  </Button>

                  <Button
                    block
                    color={
                      form.status_payment === Constants.PAYMENT_TYPES.TO_PAY
                        ? " "
                        : "white"
                    }
                    onClick={() =>
                      this.change(
                        Constants.PAYMENT_TYPES.TO_PAY,
                        "status_payment",
                      )
                    }
                  >
                    POR PAGAR
                  </Button>
                </section>

                <section className="inputs">
                  <div className="left">
                    <Button
                      className="btn-dark btn-back"
                      onClick={() => this.changeStep(STEP.PRODUCTS)}
                    >
                      <img src={LeftArrowIcon} alt="Regresar" />
                      <span>REGRESAR</span>
                    </Button>

                    <p className="client-name">Cliente: {form.client?.name}</p>
                  </div>

                  <div className="form-group">
                    <label className="material">N° Factura</label>
                    <NumberFormat
                      value={form.nextBillNumber}
                      className="form-control material"
                      placeholder={form.nextBillNumber}
                      allowNegative={false}
                      decimalScale={2}
                      onValueChange={async (v) => {
                        await this.change(v.value, "nextBillNumber");
                      }}
                      disabled={true}
                    />
                  </div>

                  {form.status_payment === Constants.PAYMENT_TYPES.TO_PAY && (
                    <>
                      <div className="form-group">
                        <label className="material">Pago inicial</label>
                        <NumberFormat
                          value={form.initial_payment}
                          className="form-control material"
                          placeholder="Opcional"
                          allowNegative={false}
                          decimalScale={2}
                          onValueChange={(v) =>
                            this.change(v.value, "initial_payment")
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label className="material">Días de crédito</label>
                        <NumberFormat
                          value={form.credit_days}
                          className="form-control material"
                          allowNegative={false}
                          decimalScale={0}
                          onValueChange={(v) =>
                            this.change(v.value, "credit_days")
                          }
                        />
                      </div>
                    </>
                  )}
                </section>

                <div className="tables">
                  <section className="table-wrapper payment-methods">
                    <table>
                      <thead className="bg-dark">
                        <tr>
                          <th>Moneda</th>
                          <th>Monto $</th>
                          <th>
                            Monto{" "}
                            {Globals.getLocalCurrencySymbol(this.props.user)}
                          </th>
                          {form.status_payment ===
                            Constants.PAYMENT_TYPES.TO_PAY && <th>IGTF 3%</th>}
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {form.methods_selected.map((item, index) => (
                          <PaymentItem
                            key={`payment-${index}`}
                            item={item}
                            statusPayment={form.status_payment}
                            onChange={(value, isLocalCurrency = false) =>
                              this.changePaymentAmount(
                                index,
                                value,
                                isLocalCurrency,
                              )
                            }
                            onRemove={() => this.removePaymentMethod(index)}
                          />
                        ))}

                        <tr>
                          <td
                            colSpan={
                              form.status_payment ===
                              Constants.PAYMENT_TYPES.TO_PAY
                                ? 5
                                : 4
                            }
                          >
                            <Select
                              value=""
                              caret
                              options={filteredPaymentMethods.map((m) => ({
                                value: m.id,
                                label: m.name,
                              }))}
                              onChange={(e) =>
                                this.addPaymentMethod(Number(e.target.value))
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>

                  <div>
                    <p style={{fontWeight: "bold", fontSize: "16px"}}>
                      Detalle de la Factura
                    </p>

                    <section className="table-wrapper">
                      <table>
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th>Código</th>
                            <th>Descripción</th>
                            <th>Cantidad</th>
                            <th>Precio</th>
                            <th>Descuento (%)</th>
                            <th>IVA</th>
                            <th>Subtotal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {form.details.map((item, index) => (
                            <tr key={index.toString()}>
                              <td>{index + 1}</td>
                              <td>{item.code}</td>
                              <td>
                                {item.name} ({item.iva_txt})
                              </td>
                              <td className="quantity">
                                <input value={item.quantity} readOnly />
                              </td>
                              <td>{item.sale_price}</td>
                              <td>{item.discount || "--"}</td>
                              <td>
                                {item.exento === Constants.PRODUCT_EXENTO.NO
                                  ? `(${item.iva_porcentage}%) ${Globals.formatMiles(
                                      item.iva_usd,
                                    )}`
                                  : "--"}
                              </td>
                              <td>
                                {Globals.formatMiles(
                                  parseFloat(item.subtotal).toFixed(2),
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>
              </section>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Totals
                  totals={totals}
                  isPaymentStep
                  isSubmittedForm={isSubmittedForm}
                  onSubmit={() => this.submit()}
                  form={form}
                  onChange={(v, t) => this.change(v, t)}
                  localCurrencySymbol={Globals.getLocalCurrencySymbol(
                    this.props.user,
                  )}
                />
              </div>
            </main>
          </div>
        </Menu>
      );

    return (
      <Menu
        history={this.props.history}
        hideContentBreadcumbs
        leftSlot={
          <HeaderContent
            tab={tab}
            onChangeTab={this.changeTab}
            onGoBack={() => this.goBack()}
          />
        }
      >
        {this.renderLoteAgotadoModal()}
        <Modal
          className="modal-report-sale-products"
          title="Productos"
          onClose={this.toggleProductsModal}
          visible={visible_products}
          size="lg"
        >
          <ModalProducts
            onSelectProduct={this.addProduct}
            onClose={this.toggleProductsModal}
            warehouses={this.state.warehouses}
            formatWarehouses={this.state.formatWarehouses}
          />
        </Modal>

        <Modal
          size="lg"
          className="modal-report-sale-client"
          title="Registrar cliente"
          onClose={this.toggleClientModal}
          visible={visible_client}
        >
          <CreateEditClient
            user={this.props.user}
            createFromPOS={true}
            zones={zones}
            onSuccess={(client) => this.setState({created_client: client})}
            onClose={(reload = false) => {
              if (reload) this.getClients();
              this.toggleClientModal();
            }}
            client_categories={filtered_clientCategories}
          />
        </Modal>

        <Modal
          className="modal-report-sale-client"
          title="CUENTAS PENDIENTES CLIENTE"
          onClose={() => this.setState({clientOrdersToPay: null})}
          visible={clientOrdersToPay}
        >
          <p>
            Cliente: <b>{clientOrdersToPay?.name}</b>
          </p>
          <table border={1} style={{border: "collapse", width: "100%"}}>
            <thead>
              <tr style={{textAlign: "center"}}>
                <th>Cuenta</th>
                <th>Fecha</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>
              {clientOrdersToPay?.to_pay_orders?.map((item, index) => (
                <tr key={index} style={{textAlign: "right"}}>
                  <td style={{textAlign: "center"}}>{item?.number_format}</td>
                  <td style={{textAlign: "center"}}> {item?.created_es} </td>
                  <td style={{textAlign: "right"}}>
                    ${Globals.formatMiles(item?.to_pay)}
                  </td>
                </tr>
              ))}
              <tr style={{textAlign: "right"}}>
                <td colSpan={2}>
                  <b>Total ctas. por cobrar:</b>
                </td>
                <td>
                  <b>$ {Globals.formatMiles(total_client_to_pay)}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </Modal>

        <div id="report-sale-create">
          <div className="filters-row">
            <section className="filters">
              <div className="row">
                <div className="col-4">
                  <SelectActions
                    label="Nombre del cliente"
                    placeholder="Nombre del Cliente o Rif"
                    isSearchable
                    actionOptions={[
                      {
                        onClick: () => this.toggleClientModal(),
                        content: (
                          <div style={{color: "#3A7FC2"}}>
                            <span>Registrar nuevo cliente</span>
                            <i
                              className="fa fa-regular fa-plus"
                              style={{marginLeft: "0.75rem"}}
                            />
                          </div>
                        ),
                      },
                    ]}
                    options={clients.map((i) => ({
                      value: i.id,
                      label: i.label,
                      actions: [],
                    }))}
                    value={form.client_id}
                    onChange={this.onSelectClient}
                    onInputChange={this.debouncingSearchClient}
                  />
                </div>
              </div>

              <div>
                {form.client_id && (
                  <div className="client-address">
                    <img src={LocationPinIcon} alt="Dirección del cliente" />
                    <p>{form.client?.address}</p>
                  </div>
                )}
              </div>

              <div>
                {form.client_id && form.client?.to_pay_orders?.length > 0 && (
                  <div className="client-address">
                    <p style={{color: "red"}}>
                      {"Cliente posee cuenta por cobrar pendiente,"}
                    </p>
                    &nbsp;
                    <span
                      style={{color: "red"}}
                      className="clickable"
                      onClick={() =>
                        this.setState({clientOrdersToPay: form.client})
                      }
                    >
                      {"ver detalles"}
                    </span>
                  </div>
                )}
              </div>
            </section>

            <Totals
              totals={totals}
              form={form}
              localCurrencySymbol={Globals.getLocalCurrencySymbol(
                this.props.user,
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
              marginBottom: "15px",
              paddingRight: "10px",
            }}
          >
            <div style={{fontWeight: "bold", fontSize: "16px"}}>
              Cambio Oficial BCV: Bs.{" "}
              {Globals.newFormatMiles(this.state.exchangeRate, 4)}
            </div>
          </div>

          <section className="table-wrapper">
            <div className="table-header">
              <Button
                onClick={() => this.toggleProductsModal()}
                disabled={isLoadingWarehouses}
              >
                <div className="loader-wrapper">
                  {isLoadingWarehouses && <div className="loader" />}
                  <span>AGREGAR PRODUCTO</span>
                </div>
              </Button>

              {!!form.details.length && (
                <Button color="green" onClick={() => this.goToPaymentStep()}>
                  SIGUIENTE
                </Button>
              )}
            </div>
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Stock</th>
                  <th>Cantidad{"\n"}solicitada</th>
                  <th>Precio</th>
                  <th>Descuento (%)</th>
                  <th>IVA</th>
                  <th>Subtotal</th>
                  <th className="actions"></th>
                </tr>
              </thead>
              <tbody>
                {form.details.map((item, index) => {
                  const stockToValidate = this.getItemStock(item);
                  return (
                    <tr key={index.toString()}>
                      <td>{index + 1}</td>
                      <td>{item.code}</td>
                      <td>
                        {item.name} ({item.iva_txt})
                      </td>
                      <td>{stockToValidate}</td>
                      <td className="quantity">
                        <Button
                          small
                          onClick={() => this.oneLessProduct(index)}
                        >
                          <i className="fa fa-minus" />
                        </Button>
                        <input
                          value={item.quantity}
                          onChange={(e) => {
                            if (
                              item?.decimal_stock === Constants.DECIMAL_STOCK.NO
                            ) {
                              if (
                                Globals.validateInteger(e.target.value) ||
                                e.target.value === ""
                              ) {
                                if (Number(e.target.value) > stockToValidate)
                                  return;
                                this.changeManual(index, e.target.value);
                              }
                            } else {
                              if (Number(e.target.value) > stockToValidate)
                                return;
                              this.changeManual(index, e.target.value);
                            }
                          }}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              this.changeManual(index, "0");
                            }
                          }}
                        />
                        <Button
                          small
                          onClick={() => this.oneMoreProduct(index)}
                        >
                          <i className="fa fa-plus" />
                        </Button>
                      </td>
                      <td>{item.sale_price}</td>
                      <td>{item.discount || "--"}</td>
                      <td>
                        {item.exento === Constants.PRODUCT_EXENTO.NO
                          ? `(${item.iva_porcentage}%) ${Globals.formatMiles(
                              item.iva_usd,
                            )}`
                          : "--"}
                      </td>
                      <td>
                        {Globals.formatMiles(
                          parseFloat(item.subtotal).toFixed(2),
                        )}
                      </td>
                      <td>
                        <img
                          src={CloseIcon}
                          className="btn-remove"
                          title="Remover producto"
                          alt="Remover producto"
                          onClick={() => this.removeProduct(index)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        </div>
      </Menu>
    );
  }
}

const HeaderContent = ({onChangeTab, onGoBack, tab}) => (
  <>
    <div className="back-button">
      <img src={LeftArrowIcon} onClick={() => onGoBack()} alt="Regresar" />
    </div>
    <div className="report-sale-tabs">
      <HeaderTab
        icon={AddIcon}
        label="Nuevo Pedido"
        isSelected={tab === TAB.NEW}
        onClick={() => onChangeTab(TAB.NEW)}
      />
      <HeaderTab
        icon={ReturnIcon}
        label="Nota de crédito"
        isSelected={tab === TAB.RETURN}
        onClick={() => onChangeTab(TAB.RETURN)}
      />
      <HeaderTab
        icon={DebitIcon}
        label="Nota de débito"
        isSelected={tab === TAB.DEBIT}
        onClick={() => onChangeTab(TAB.DEBIT)}
      />
    </div>
  </>
);

const HeaderTab = ({icon, isSelected, label, onClick}) => (
  <div
    className={"report-sale-tab" + (isSelected ? " active" : "")}
    onClick={onClick}
  >
    <img src={icon} alt={label} />
    <span>{label}</span>
  </div>
);

const Totals = ({
  totals,
  isPaymentStep,
  onSubmit,
  isSubmittedForm = false,
  form,
  onChange,
  localCurrencySymbol,
}) => (
  <div className="totals-wrapper">
    <ul className="totals">
      {isPaymentStep ? (
        <>
          <li>
            <span>Subtotal</span>
            <span className="amount">
              <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
              {Globals.formatMiles(totals.subtotal_without_disc_bs)}
            </span>
          </li>
          <li>
            <span>Descuentos</span>
            <span className="amount">
              <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
              {Globals.formatMiles(totals.discount_bs)}
            </span>
          </li>
        </>
      ) : (
        <li>
          <span>Subtotal</span>
          <span className="amount">
            <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
            {Globals.formatMiles(totals.subtotal_bs)}
          </span>
        </li>
      )}

      {!!isPaymentStep && (
        <div>
          {totals.iva_16_bs > 0 && (
            <li>
              <span>IVA ({Constants.TAXES.IVA}%)</span>
              <span className="amount">
                <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
                {Globals.formatMiles(totals.iva_16_bs)}
              </span>
            </li>
          )}
          {totals.iva_8_bs > 0 && (
            <li>
              <span>IVA ({Constants.TAXES.IVA_8}%)</span>
              <span className="amount">
                <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
                {Globals.formatMiles(totals.iva_8_bs)}
              </span>
            </li>
          )}
          {totals.iva_31_bs > 0 && (
            <li>
              <span>IVA ({Constants.TAXES.IVA_31}%)</span>
              <span className="amount">
                <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
                {Globals.formatMiles(totals.iva_31_bs)}
              </span>
            </li>
          )}
          {totals.igtf_bs > 0 && (
            <li>
              <span>IGTF ({Constants.TAXES.IGTF}%)</span>
              <span className="amount">
                <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
                {Globals.formatMiles(totals.igtf_bs)}
              </span>
            </li>
          )}
          <hr />
        </div>
      )}

      <li>
        <span>Total</span>
        <div>
          <div className="amount bold red" style={{fontSize: 22}}>
            <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
            {Globals.formatMiles(totals.total_bs)}
          </div>
          <div className="amount bold green" style={{fontSize: 18}}>
            $ {Globals.formatMiles(totals.total_usd)}
          </div>
        </div>
      </li>

      {!!isPaymentStep && (
        <>
          <hr />
          <li>
            <span>Cancelado</span>
            <span className="amount">
              <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
              {Globals.formatMiles(totals.paid_bs)}
            </span>
          </li>
          <li>
            <span>Restante</span>
            <span className="amount">
              <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
              {Globals.formatMiles(totals.left_bs)}
            </span>
          </li>
          <li>
            <span>Cambio</span>
            <div>
              <div className="amount red" style={{fontSize: 16}}>
                <span style={{fontSize: 14}}>{localCurrencySymbol} </span>
                {Globals.formatMiles(totals.change_bs)}
              </div>
              <div className="amount green" style={{fontSize: 16}}>
                $ {Globals.formatMiles(totals.change_usd)}
              </div>
            </div>
          </li>
          <hr />
          <li>
            <div className="form-group">
              <label className="material">Descuento (%)</label>
              <NumberFormat
                value={form.discount}
                className="form-control material"
                placeholder="Opcional"
                allowNegative={false}
                decimalScale={2}
                onValueChange={(v) => onChange(v.value, "discount")}
              />
            </div>
          </li>
          <hr />
          <li style={{padding: "0.5rem 1rem"}}>
            <Button
              color="green"
              block
              onClick={() => onSubmit()}
              disabled={isSubmittedForm}
            >
              {isSubmittedForm ? (
                <Spinner animation="border" size="sm" role="status" />
              ) : (
                <span>PAGAR</span>
              )}
            </Button>
          </li>
        </>
      )}
    </ul>
  </div>
);

const PaymentItem = ({item, index, onChange, onRemove, statusPayment}) => {
  const [bsHasChaged, setBsHasChaged] = useState(false);
  const igtf = !item.isLocalCurrency
    ? parseFloat(item.amount * 0.03).toFixed(2)
    : "0.00";

  return (
    <tr key={`payment-${index}`}>
      <td>{item.name}</td>
      <td>
        {!item.isLocalCurrency ? (
          <NumberFormat
            value={item.amount}
            allowNegative={false}
            decimalScale={2}
            onFocus={() => setBsHasChaged(false)}
            onValueChange={(v) => !bsHasChaged && onChange(v.value)}
          />
        ) : (
          Globals.formatMiles(parse(Number(item.amount)))
        )}
      </td>
      <td>
        {item.isLocalCurrency ? (
          <NumberFormat
            value={item.amount_bs}
            allowNegative={false}
            decimalScale={2}
            onFocus={() => setBsHasChaged(true)}
            onValueChange={(v) => bsHasChaged && onChange(v.value, true)}
          />
        ) : (
          Globals.formatMiles(parse(Number(item.amount_bs)))
        )}
      </td>
      {statusPayment === Constants.PAYMENT_TYPES.TO_PAY && (
        <td>{!item.isLocalCurrency ? `$ ${igtf}` : "--"}</td>
      )}
      <td>
        <img
          src={CloseIcon}
          className="btn-remove"
          title="Remover método de pago"
          alt="Remover método de pago"
          onClick={() => onRemove()}
        />
      </td>
    </tr>
  );
};

export default connect((state) => ({
  user: state.user,
  currency: state.currency,
}))(NewRequest);
